import BaseModel from '@/models/base';

export default class StripeSubscriptionModel extends BaseModel {
  defaults() {
    return {};
  }
}
